export default __webpack_public_path__ + "static/media/particleNotePrimary.b05d45c6.svg";